var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 932,
    viewBox: "0 0 1000 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_886_26227",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1000,
    height: 932
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000 0.25H0V931.43H1000V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_886_26227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 0.25H0V931.43H1000V0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000391006 834.49L424.43 585.26L1058.78 948.87L167.19 1133.52L-8.84961 949.94L0.000391006 834.49Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.091 446.83C340.541 446.72 340.991 446.66 341.461 446.66C347.861 446.66 352.911 457.03 356.641 461.44C390.741 501.74 388.901 490.05 429.481 494.63C404.771 473.13 387.291 474.6 379.301 463.63C374.321 456.79 382.141 447.96 389.581 452.03C430.721 474.45 464.951 453.38 495.681 520.59C498.311 526.33 501.851 531.61 506.211 536.16C536.961 568.17 568.051 600.02 595.121 635.07C605.691 612.23 609.87 613.83 634.5 537.06C641.94 552.29 650.851 566.94 661.151 580.15C658.891 607.91 649.181 626.54 649.181 651.82C649.181 677.1 659.16 694.14 667.06 716.08C640.29 771.6 629.651 778.03 614.041 778.03C575.481 778.03 528.491 699.52 444.331 565.68C440.991 560.36 436.541 555.78 431.191 552.47C406.171 536.95 388.281 546.83 369.641 538.49C349.391 529.44 328.521 474.93 328.521 465.1C328.521 462.04 329.921 457.73 332.121 454.05C334.231 450.5 337.081 447.57 340.101 446.83H340.091Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.07 716.08C640.3 771.6 629.66 778.03 614.05 778.03C575.49 778.03 528.5 699.52 444.34 565.68C441 560.36 436.55 555.78 431.2 552.47C406.18 536.95 388.29 546.83 369.65 538.49C349.4 529.44 328.53 474.93 328.53 465.1C328.53 462.04 329.94 457.73 332.13 454.05C334.24 450.51 337.09 447.57 340.11 446.83C340.56 446.72 341.01 446.66 341.48 446.66C347.88 446.66 352.93 457.03 356.66 461.44C390.76 501.74 388.92 490.05 429.5 494.63C404.79 473.13 387.31 474.6 379.32 463.63C374.34 456.79 382.16 447.96 389.6 452.03C430.74 474.45 464.97 453.38 495.7 520.59C498.33 526.33 501.87 531.61 506.23 536.16C536.98 568.17 568.06 600.03 595.14 635.07C602.38 644.44 609.34 654.03 615.91 663.92",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.131 635.07C605.701 612.23 609.881 613.83 634.511 537.06",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11 454.05C342.14 477.38 359.75 508.43 374.2 516.79",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.091 446.83C351.091 466.6 359.991 485.37 377.151 502.28",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.27 522.44C795.7 523.26 796.32 524 797.13 524.6C797.16 524.62 797.18 524.65 797.21 524.67C799.18 526.14 801.84 526.29 804 525.12C811.56 521.09 820.5 517.18 828.01 517.18C835.52 517.18 840.28 521.66 845.57 527.33C822.95 559.97 788.21 560.62 788.21 610.62C788.21 660.62 791.39 791.37 820.67 866.56H820.65C764.6 864.02 719.27 835.57 681.41 794.05C677.92 790.2 676.09 785.12 676.28 779.9C676.41 776.51 676.5 773.09 676.5 769.7C676.5 746.98 672.24 730.4 667.07 716.07C659.18 694.13 649.19 677.39 649.19 651.81C649.19 626.23 658.91 607.9 661.16 580.14C650.86 566.93 641.95 552.28 634.51 537.05C629.61 527.02 625.35 516.72 621.75 506.4C654.89 441.29 664.19 392.34 718.6 388.75C726.49 414.03 741.48 431.06 764.35 439.84C761.86 459.09 760.09 476.04 760.09 497.73C760.09 513.36 763.58 525.67 779.15 525.67C779.2 525.67 785.15 524.93 795.27 522.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.27 522.44C795.7 523.26 796.32 524 797.13 524.6C797.16 524.62 797.18 524.65 797.21 524.67C799.18 526.14 801.84 526.29 804 525.12C811.56 521.09 820.5 517.18 828.01 517.18C835.52 517.18 840.28 521.66 845.57 527.33C822.95 559.97 788.21 560.62 788.21 610.62C788.21 660.62 791.39 791.37 820.67 866.56H820.65C764.6 864.02 719.27 835.57 681.41 794.05C677.92 790.2 676.09 785.12 676.28 779.9C676.41 776.51 676.5 773.09 676.5 769.7C676.5 746.98 672.24 730.4 667.07 716.07C659.18 694.13 649.19 677.39 649.19 651.81C649.19 626.23 658.91 607.9 661.16 580.14C650.86 566.93 641.95 552.28 634.51 537.05C629.61 527.02 625.35 516.72 621.75 506.4C654.89 441.29 664.19 392.34 718.6 388.75C726.49 414.03 741.48 431.06 764.35 439.84C761.86 459.09 760.09 476.04 760.09 497.73C760.09 513.36 763.58 525.67 779.15 525.67C779.2 525.67 785.15 524.93 795.27 522.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.6 388.75C664.19 392.35 654.89 441.29 621.75 506.4C625.35 516.72 629.61 527.02 634.51 537.05C641.95 552.28 650.86 566.93 661.16 580.14L661.18 580.16",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.32 517.75C661.3 524.82 660.84 531.9 660.84 538.97C660.84 546.51 661.64 558.75 661.64 568.73C661.64 572.71 661.47 576.52 661.17 580.15C658.89 607.91 649.2 626.54 649.2 651.82C649.2 677.1 659.18 694.15 667.08 716.08",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.63 689.83C1039.86 690.73 1039.98 691.69 1039.98 692.69C1039.98 706.9 1020.1 722.72 997.221 736.18C1005.2 711.68 1011.3 690.25 1015.11 676.27C1026.71 677.96 1037.55 681.7 1039.62 689.83H1039.63Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.34 503.16C809.34 503.8 804.44 504.72 799.62 506.05C797.95 506.5 795.51 506.97 793.32 506.97C790.49 506.97 788.05 506.22 788.05 503.71C788.05 493.24 830.69 479.35 837.21 479.35C843.23 479.35 848.75 481.74 854.33 483.71L854.48 483.31C845.13 475.32 836.64 464.46 830.85 453.41C829.04 449.97 827.49 446.49 826.28 443.09C825.76 441.62 825.65 440.1 825.9 438.66C826.41 435.72 828.37 433.09 831.3 431.84L831.42 431.79C835.4 430.08 840.02 431.42 842.51 434.93C842.91 435.5 843.31 436.05 843.71 436.59C861.15 459.93 882 465.27 895.77 475.47C904.7 482.08 910.62 490.72 910.62 507.69C910.62 528.96 893.61 535.67 871.21 587.87C867.78 595.86 866.76 604.69 868.2 613.27C876.36 662.01 883.07 690.64 888.65 710.37C889.9 709.6 891.18 708.83 892.45 708.08C923.78 689.5 960.11 674.94 993.6 674.94C999.57 674.94 1007.5 675.16 1015.12 676.26C1011.31 690.24 1005.2 711.68 997.23 736.17C994.59 744.23 991.76 752.62 988.74 761.19C962.65 835.03 922.32 921.9 876.32 921.9C851.44 921.9 833.55 899.59 820.69 866.55C791.41 791.35 788.23 660.54 788.23 610.61C788.23 560.68 822.96 559.96 845.59 527.32C840.31 521.65 835.27 517.17 828.03 517.17C820.79 517.17 811.58 521.08 804.02 525.11C801.86 526.28 799.2 526.13 797.23 524.66C797.2 524.64 797.18 524.61 797.15 524.59C796.35 523.99 795.73 523.25 795.29 522.43C793.95 519.92 794.35 516.69 796.66 514.69C801.98 510.07 807.95 506.03 814.35 503.15L814.34 503.16Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.43 329.81C953.07 342.12 949.35 355.95 942.93 368.4C937.45 379.07 929.94 388.75 921.31 395.46C919.92 396.55 918.48 397.57 917.01 398.52C910.61 402.65 904.49 404.64 899.05 404.66C898.82 404.66 898.58 404.66 898.35 404.64C895.26 404.5 892.41 403.85 889.86 402.53C882.67 398.83 877.94 390.39 877.35 378.07C876.76 365.96 880.29 352.35 886.53 340.06C892.95 327.4 902.21 316.11 912.75 309.36C923.13 302.69 932.73 301.67 939.92 305.36C946.17 308.57 950.5 315.43 951.98 325.29C952.19 326.71 952.35 328.23 952.43 329.8V329.81ZM928.38 360.89C931.46 354.9 933.21 348.25 932.95 342.33C932.67 336.43 930.39 332.36 926.93 330.59C923.47 328.8 918.85 329.3 913.85 332.5C908.78 335.76 904.35 341.2 901.24 347.27C898.25 353.17 896.56 359.73 896.84 365.55C897.11 371.49 899.4 375.55 902.86 377.31C906.29 379.1 910.92 378.6 915.9 375.39C920.88 372.2 925.3 366.88 928.37 360.91L928.38 360.89Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.94 342.33C933.21 348.25 931.45 354.9 928.37 360.89C925.29 366.86 920.88 372.18 915.9 375.37C910.92 378.58 906.28 379.08 902.86 377.29C899.4 375.53 897.11 371.47 896.84 365.53C896.56 359.71 898.24 353.16 901.24 347.25C904.35 341.18 908.78 335.75 913.85 332.48C918.85 329.29 923.47 328.78 926.93 330.57C930.39 332.34 932.67 336.41 932.95 342.31L932.94 342.33Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.81 446.9L929.81 447.35V447.37C918.51 458.12 907.05 467.42 895.76 475.48C882 465.28 861.1 459.98 843.7 436.6C851.94 431.6 859.74 426.67 867.11 421.58C867.13 421.6 867.14 421.63 867.16 421.65C868.46 423.46 870.5 424.43 872.58 424.43C873.93 424.43 875.31 424.01 876.49 423.16C884.67 417.27 891.86 411.39 898.3 405.35C898.23 406.64 898.2 407.93 898.2 409.21C898.2 433.64 909.48 438.22 928.8 446.9H928.81Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.371 377.58C985.161 347.25 960.511 292.18 934.661 283.12C931.751 209.91 885.511 162.2 825.271 166.8V166.82C827.641 167.91 830.07 169.14 832.51 170.57C842.74 176.47 852.44 184.65 861.19 194.31C884.97 220.58 901.471 257.82 901.471 289.99V291.13C906.691 290.08 911.441 290.68 915.431 292.74L939.911 305.35V305.37C946.161 308.58 950.511 315.44 951.971 325.3C952.191 326.72 952.341 328.24 952.421 329.81C953.041 342.12 949.341 355.95 942.921 368.4C937.441 379.07 929.931 388.75 921.301 395.46C919.911 396.55 918.47 397.57 917 398.52C910.6 402.65 904.481 404.62 899.041 404.66C898.791 404.89 898.561 405.13 898.301 405.35C898.231 406.64 898.201 407.93 898.201 409.21C898.201 433.64 909.471 438.24 928.801 446.9L929.801 447.35C1021.27 488.63 1014.94 513.64 1027.31 612.13C1035.78 598.32 1040.81 588.62 1045.68 574.69C1088.21 453.05 972.351 377.59 972.351 377.59L972.371 377.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.051 404.66C898.801 404.89 898.571 405.13 898.311 405.35C898.331 405.12 898.331 404.88 898.341 404.65C898.571 404.67 898.811 404.67 899.041 404.67L899.051 404.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.351 404.64C898.331 404.87 898.33 405.11 898.32 405.34C891.88 411.38 884.701 417.26 876.511 423.15C875.321 424 873.951 424.42 872.601 424.42C870.531 424.42 868.491 423.45 867.181 421.64C867.161 421.62 867.15 421.59 867.13 421.57C865.02 418.58 865.71 414.45 868.69 412.29C874.48 408.11 879.731 403.96 884.531 399.78L889.861 402.52C892.421 403.84 895.261 404.56 898.351 404.63V404.64Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.44 708.09C891.17 708.84 889.9 709.61 888.64 710.38C883.05 690.65 876.35 662.02 868.19 613.28C866.75 604.7 867.77 595.87 871.2 587.88C893.61 535.67 910.61 528.97 910.61 507.7C910.61 490.73 904.69 482.08 895.76 475.48C907.05 467.42 918.5 458.12 929.81 447.37V447.35C1041.65 497.82 1007.28 523.97 1039.66 689.83H1039.63C1037.59 681.69 1026.72 677.96 1015.12 676.27C1007.49 675.17 999.57 674.95 993.6 674.95C960.11 674.95 923.78 689.52 892.45 708.09H892.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.44 292.74L939.92 305.35V305.37C932.73 301.67 923.13 302.69 912.75 309.37C902.22 316.13 892.95 327.41 886.53 340.07C880.29 352.36 876.76 365.97 877.35 378.08C877.94 390.4 882.67 398.85 889.86 402.54L865.36 389.92C858.19 386.22 853.44 377.78 852.85 365.46C852.63 360.91 853 356.15 853.87 351.33C855.12 344.51 857.34 337.54 860.39 330.9C860.92 329.74 861.47 328.59 862.05 327.46C866.83 317.97 873.27 309.28 880.58 302.69C883.05 300.45 885.61 298.46 888.27 296.75C892.87 293.79 897.33 291.97 901.48 291.15C906.7 290.1 911.45 290.7 915.44 292.76V292.74Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.57 302.07V302.67C873.26 309.26 866.82 317.94 862.04 327.44C861.47 328.58 860.92 329.73 860.38 330.88C802.99 320.13 766.74 297.42 721.91 247.57C719.12 261.92 716.89 275.5 715.25 288.3C701.69 256.29 707.66 235.68 727.91 216.41C733.8 210.81 739.7 205.71 745.58 201.11C752.9 195.36 760.21 190.37 767.47 186.14C775.6 181.34 783.66 177.48 791.6 174.48C797.94 175.92 804.64 178.59 811.6 182.61C814.63 184.37 817.64 186.32 820.56 188.46C854.4 213.06 880.56 261.57 880.56 302.05L880.57 302.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.34 483.72C848.75 481.75 843.24 479.36 837.22 479.36C830.7 479.36 788.06 493.26 788.06 503.72C788.06 506.23 790.5 506.98 793.33 506.98C795.52 506.98 797.96 506.51 799.63 506.06C804.45 504.72 809.35 503.8 814.35 503.17C807.95 506.05 801.98 510.09 796.66 514.71C794.35 516.72 793.95 519.94 795.29 522.45C785.17 524.94 779.22 525.68 779.17 525.68C763.6 525.68 760.11 513.37 760.11 497.74C760.11 476.05 761.88 459.1 764.37 439.85C741.49 431.07 726.51 414.05 718.62 388.76C710.74 363.53 709.89 330.05 715.28 288.31C716.92 275.5 719.14 261.92 721.94 247.58C766.77 297.43 803.02 320.14 860.41 330.89C857.38 337.55 855.14 344.5 853.89 351.32C853.02 356.14 852.65 360.9 852.87 365.45C853.46 377.77 858.2 386.22 865.38 389.91L884.54 399.79C879.74 403.97 874.49 408.12 868.7 412.3C865.72 414.46 865.04 418.59 867.14 421.58C859.77 426.66 851.97 431.6 843.73 436.6C843.33 436.06 842.93 435.51 842.53 434.94C840.04 431.43 835.42 430.09 831.44 431.8L831.32 431.85C828.39 433.1 826.42 435.73 825.92 438.67C822.24 434.49 816.84 431.83 810.82 431.83C799.72 431.83 790.72 440.84 790.72 451.95C790.72 463.06 799.72 472.05 810.82 472.05C821.92 472.05 830.12 463.82 830.87 453.42C836.66 464.47 845.15 475.33 854.5 483.32L854.35 483.72H854.34Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.29 443.1C827.5 446.5 829.05 449.97 830.86 453.42C830.11 463.82 821.41 472.05 810.81 472.05C800.21 472.05 790.71 463.04 790.71 451.95C790.71 440.86 799.71 431.83 810.81 431.83C816.83 431.83 822.23 434.49 825.91 438.67C825.66 440.11 825.77 441.63 826.29 443.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.47 289.99V291.13C897.32 291.95 892.86 293.77 888.26 296.73C885.6 298.44 883.04 300.43 880.57 302.67V302.07C880.57 261.59 854.42 213.08 820.57 188.48C817.64 186.34 814.63 184.38 811.61 182.63C804.65 178.62 797.95 175.94 791.61 174.5C785.47 173.11 779.69 172.89 774.4 173.75C770.34 174.4 766.57 175.69 763.16 177.63V177.61L783.74 165.74C794.61 159.45 809.11 159.44 825.26 166.83C827.63 167.92 830.06 169.15 832.5 170.58C842.73 176.48 852.43 184.66 861.18 194.32C884.96 220.59 901.46 257.83 901.46 290L901.47 289.99Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.41 173.74C771.58 177.2 769.24 181.35 767.47 186.13L767.49 186.15C760.23 190.38 752.93 195.36 745.6 201.12L745.58 201.1C748.91 190.3 754.93 182.37 762.85 177.79L763.17 177.61V177.63C766.58 175.69 770.34 174.4 774.41 173.75V173.74Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.26 288.31C701.7 256.3 707.67 235.69 727.92 216.42C733.81 210.82 739.71 205.73 745.59 201.12C752.92 195.38 760.23 190.41 767.48 186.15C775.62 181.37 783.67 177.49 791.61 174.49H791.63",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.271 166.8C885.521 162.2 931.751 209.91 934.661 283.12C960.511 292.18 985.161 347.25 972.371 377.58C972.371 377.58 1114.35 469.54 1027.36 612.37",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.391 330.88C803.001 320.13 766.751 297.42 721.921 247.57C719.131 261.92 716.911 275.5 715.261 288.3C709.901 330.04 710.731 363.51 718.601 388.75C726.491 414.03 741.471 431.07 764.351 439.84C766.841 440.79 769.421 441.65 772.091 442.4C774.051 442.95 776.051 443.45 778.111 443.89",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.34 331.56C758.93 335.62 759.24 339.75 759.24 343.85C759.24 369.42 747.87 371.32 747.87 380.27C747.87 386.07 755.9 390.19 761.25 392.28",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.88 304.84C727.35 305.56 735.01 306.38 742.18 308.37C746.8 309.66 751.23 311.48 755.04 314.07",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.44 332.89C801.63 336.49 817.53 347.19 821.71 358.37",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.92 305.36C932.73 301.67 923.13 302.68 912.75 309.36C902.22 316.12 892.95 327.4 886.53 340.06C880.29 352.35 876.76 365.96 877.35 378.07C877.94 390.39 882.67 398.83 889.86 402.53C892.42 403.85 895.26 404.49 898.35 404.64C898.58 404.65 898.82 404.66 899.05 404.66C904.48 404.64 910.6 402.65 917.01 398.52C918.48 397.57 919.92 396.55 921.31 395.46C929.94 388.75 937.45 379.07 942.93 368.4C949.35 355.94 953.06 342.11 952.43 329.81C952.35 328.24 952.19 326.72 951.98 325.3C950.5 315.44 946.18 308.58 939.92 305.37V305.36Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.92 330.59C923.46 328.8 918.84 329.3 913.84 332.5C908.77 335.76 904.34 341.2 901.23 347.27C898.24 353.17 896.55 359.73 896.83 365.55C897.1 371.49 899.39 375.55 902.85 377.31C906.28 379.1 910.91 378.6 915.89 375.39C920.87 372.2 925.29 366.88 928.36 360.91C931.44 354.92 933.19 348.27 932.93 342.35C932.65 336.45 930.37 332.38 926.91 330.61L926.92 330.59Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.92 305.34L915.44 292.73C911.44 290.67 906.7 290.08 901.48 291.12C897.33 291.95 892.87 293.76 888.27 296.72C885.61 298.43 883.05 300.42 880.58 302.66C873.28 309.26 866.83 317.93 862.05 327.43C861.48 328.57 860.93 329.72 860.39 330.87C857.34 337.51 855.12 344.48 853.87 351.3C853 356.12 852.63 360.88 852.85 365.43C853.44 377.75 858.18 386.2 865.36 389.89L889.86 402.51",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.42 173.71L774.4 173.74C771.57 177.2 769.23 181.35 767.46 186.13",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.57 302.67V302.07C880.57 261.59 854.42 213.08 820.57 188.48C817.64 186.34 814.63 184.38 811.61 182.63C804.65 178.62 797.95 175.94 791.61 174.5C785.47 173.11 779.69 172.9 774.4 173.75C770.34 174.4 766.57 175.69 763.16 177.63",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.47 291.1V290C901.47 257.83 884.97 220.59 861.19 194.32C852.44 184.65 842.75 176.48 832.51 170.58C830.07 169.16 827.64 167.92 825.27 166.83C809.12 159.44 794.62 159.46 783.75 165.74L762.85 177.8C754.92 182.38 748.9 190.31 745.58 201.11",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.86 453.42C830.11 463.82 821.41 472.05 810.81 472.05C800.21 472.05 790.71 463.04 790.71 451.95C790.71 440.86 799.71 431.83 810.81 431.83C816.83 431.83 822.23 434.49 825.91 438.67L825.93 438.69",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.721 436.59C851.961 431.59 859.761 426.66 867.131 421.57",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.05 404.66C898.8 404.89 898.56 405.12 898.31 405.35C891.76 411.26 884.69 417.27 876.5 423.16C875.31 424.01 873.94 424.43 872.59 424.43C870.52 424.43 868.48 423.46 867.17 421.65C867.15 421.63 867.14 421.6 867.12 421.58C865.01 418.59 865.7 414.46 868.68 412.3C874.47 408.12 879.78 404.05 884.52 399.79C884.76 399.58 884.99 399.37 885.22 399.17",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.351 404.64C898.331 404.87 898.331 405.11 898.321 405.34C898.241 406.63 898.221 407.92 898.221 409.2C898.221 433.63 909.501 438.21 928.821 446.89L929.821 447.34C1041.68 497.75 1004.86 524.45 1039.67 689.82C1039.78 690.34 1039.89 690.87 1039.99 691.39",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.32 517.75C661.3 524.82 660.84 531.9 660.84 538.97C660.84 546.51 661.64 558.75 661.64 568.73C661.64 572.71 661.47 576.52 661.17 580.15C658.89 607.91 649.2 626.54 649.2 651.82C649.2 677.1 659.18 694.15 667.08 716.08C672.24 730.41 676.51 746.98 676.51 769.71C676.51 773.1 676.43 776.52 676.29 779.91C676.11 785.13 677.93 790.21 681.42 794.06C719.28 835.58 764.61 864.02 820.66 866.57",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.49 483.32C845.14 475.33 836.65 464.47 830.86 453.42C829.06 449.97 827.5 446.5 826.29 443.1C825.77 441.63 825.66 440.11 825.91 438.67C826.42 435.73 828.38 433.1 831.31 431.85L831.43 431.8C835.41 430.09 840.03 431.43 842.52 434.94C842.92 435.51 843.32 436.06 843.72 436.6C861.16 459.94 882.01 465.28 895.78 475.48C904.71 482.09 910.63 490.73 910.63 507.7C910.63 528.97 893.62 535.68 871.22 587.88C867.79 595.87 866.77 604.7 868.21 613.28C876.37 662.02 883.08 690.65 888.66 710.38C899.95 750.31 906.64 753.84 911.47 813.74",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.41 489.1C868.53 487.66 864.53 486.49 860.42 485.54C858.36 485.07 856.34 484.42 854.33 483.72C848.74 481.76 843.23 479.36 837.21 479.36C830.69 479.36 788.05 493.26 788.05 503.72C788.05 506.23 790.49 506.98 793.32 506.98C795.51 506.98 797.95 506.51 799.62 506.06C804.44 504.72 809.34 503.8 814.34 503.17",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.671 501.86C847.351 500.29 840.861 498.64 834.321 498.63H834.141C827.281 498.63 820.611 500.34 814.341 503.16C807.941 506.04 801.971 510.08 796.651 514.7C794.341 516.71 793.941 519.93 795.281 522.44C795.721 523.26 796.331 524 797.141 524.6C797.171 524.62 797.191 524.65 797.221 524.67C799.191 526.14 801.851 526.29 804.011 525.12C811.571 521.09 820.511 517.18 828.021 517.18C835.531 517.18 840.291 521.66 845.581 527.33C822.961 559.97 788.221 560.62 788.221 610.62C788.221 660.62 791.401 791.36 820.681 866.56C833.541 899.6 851.431 921.91 876.311 921.91C922.311 921.91 962.641 835.04 988.731 761.2C991.761 752.64 994.591 744.25 997.221 736.18C1005.22 711.69 1011.3 690.25 1015.11 676.27",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.98 617.09C913.76 648.38 901.24 677.77 892.44 708.09",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.65 710.38C889.9 709.61 891.18 708.84 892.45 708.09C923.78 689.51 960.11 674.95 993.6 674.95C999.57 674.95 1007.5 675.16 1015.12 676.27C1026.73 677.95 1037.56 681.7 1039.63 689.83C1039.86 690.73 1039.98 691.69 1039.98 692.69C1039.98 706.9 1020.1 722.72 997.22 736.18",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.361 439.84C761.871 459.09 760.101 476.04 760.101 497.73C760.101 513.36 763.591 525.67 779.161 525.67C779.211 525.67 785.161 524.93 795.281 522.44",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.771 475.47C907.061 467.41 918.51 458.11 929.82 447.36",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.51 352.27C743.22 352.37 742.86 334.37 735.58 334.27C728.91 334.19 727.72 352.16 735.51 352.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.971 383C799.141 383.28 799.171 364.22 791.471 363.95C784.411 363.71 782.731 382.71 790.971 383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.92 890.88C780.29 891.68 780.85 892.64 780.63 893.57C780.42 894.47 779.47 895.34 777.85 895.94L678.16 933.31C674.87 934.54 670.02 934.29 667.32 932.72L425.24 792.96C424.07 792.28 423.48 791.46 423.48 790.65V790.6C423.51 789.58 424.47 788.57 426.29 787.88L525.98 750.51C529.27 749.28 534.15 749.55 536.85 751.11L778.91 890.87L778.92 890.88ZM730.9 895.94L747.99 889.54L731.71 880.14L714.62 886.55L730.9 895.94ZM702.92 879.8L720.03 873.4L703.72 863.98L686.63 870.39L702.92 879.79V879.8ZM701.39 907.01L718.51 900.58L702.23 891.19L685.12 897.6L701.38 907L701.39 907.01ZM674.95 863.65L692.04 857.24L591.84 799.39L574.75 805.8L674.95 863.65ZM673.42 890.85L690.54 884.44L674.25 875.04L657.13 881.45L673.42 890.85ZM671.92 918.05L689.01 911.65L672.73 902.25L655.64 908.66L671.92 918.05ZM645.46 874.71L662.58 868.3L646.29 858.9L629.17 865.31L645.46 874.71ZM643.96 901.9L661.05 895.5L644.76 886.08L627.67 892.49L643.96 901.89V901.9ZM617.48 858.55L634.59 852.14L618.33 842.75L601.21 849.16L617.49 858.55H617.48ZM615.99 885.76L633.08 879.35L616.79 869.95L599.68 876.36L615.99 885.76ZM589.52 842.4L606.63 835.99L590.34 826.59L573.23 833L589.52 842.4ZM588 869.6L605.09 863.2L588.81 853.8L571.72 860.21L588 869.6ZM563.05 799.04L580.14 792.64L563.85 783.22L546.76 789.63L563.05 799.03V799.04ZM561.52 826.26L578.64 819.83L562.36 810.44L545.24 816.85L561.52 826.25V826.26ZM560.03 853.45L577.12 847.05L560.83 837.63L543.74 844.04L560.03 853.44V853.45ZM535.07 782.88L552.16 776.48L535.88 767.08L518.79 773.49L535.07 782.88ZM533.56 810.1L550.68 803.69L534.39 794.29L517.27 800.7L533.56 810.1ZM532.04 837.3L549.15 830.9L532.87 821.5L515.78 827.91L532.04 837.3ZM505.58 793.95L522.69 787.52L506.41 778.13L489.3 784.54L505.58 793.94V793.95ZM504.08 821.15L521.17 814.75L504.88 805.33L487.79 811.74L504.08 821.14V821.15ZM476.1 804.99L493.19 798.59L476.91 789.19L459.82 795.6L476.1 804.99Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.641 893.57L779.151 903.42C779.01 904.34 778.341 905.22 777.141 905.91L676.71 963.9C674.01 965.46 669.611 965.46 666.921 963.9L424.841 824.14C423.471 823.36 422.781 822.31 422.811 821.26L423.491 790.65C423.491 791.46 424.081 792.29 425.251 792.96L667.33 932.72C670.03 934.28 674.881 934.54 678.171 933.31L777.861 895.94C779.481 895.34 780.431 894.47 780.641 893.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.99 889.541L730.9 895.941L714.62 886.551L731.71 880.141L747.99 889.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.02 873.401L702.92 879.8L686.62 870.401L703.71 863.98L720.02 873.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.51 900.58L701.39 907.01L685.12 897.61L702.23 891.2L718.51 900.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.04 857.241L674.95 863.651L574.75 805.801L591.84 799.391L692.04 857.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.541 884.441L673.421 890.851L657.131 881.451L674.251 875.041L690.541 884.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.011 911.651L671.921 918.05L655.641 908.66L672.731 902.25L689.011 911.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.58 868.291L645.46 874.711L629.16 865.301L646.28 858.891L662.58 868.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.05 895.51L643.96 901.9L627.66 892.5L644.75 886.09L661.05 895.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.58 852.13L617.48 858.55L601.2 849.16L618.32 842.75L634.58 852.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.081 879.35L615.991 885.76L599.681 876.36L616.791 869.94L633.081 879.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.621 835.99L589.521 842.4L573.221 833L590.331 826.59L606.621 835.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.091 863.2L588.001 869.6L571.721 860.21L588.811 853.8L605.091 863.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.141 792.651L563.051 799.04L546.761 789.641L563.851 783.23L580.141 792.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.64 819.83L561.52 826.26L545.24 816.86L562.36 810.44L578.64 819.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.13 847.061L560.03 853.451L543.74 844.051L560.83 837.641L577.13 847.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.171 776.49L535.071 782.88L518.801 773.5L535.891 767.09L552.171 776.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.681 803.68L533.561 810.1L517.261 800.7L534.381 794.28L550.681 803.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.15 830.901L532.04 837.3L515.78 827.91L532.87 821.5L549.15 830.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.691 787.531L505.581 793.951L489.301 784.551L506.411 778.141L522.691 787.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.17 814.75L504.08 821.15L487.78 811.75L504.87 805.34L521.17 814.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.19 798.59L476.1 804.99L459.82 795.61L476.91 789.19L493.19 798.59Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.49 790.651C423.49 791.461 424.08 792.291 425.25 792.961L667.33 932.721C670.03 934.281 674.88 934.541 678.17 933.311L777.86 895.941C779.48 895.341 780.43 894.471 780.64 893.571C780.85 892.641 780.29 891.681 778.93 890.881L536.87 751.121C534.17 749.561 529.29 749.291 526 750.521L426.31 787.891C424.49 788.581 423.53 789.591 423.5 790.611V790.661L423.49 790.651Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.62 886.551L730.9 895.941L747.99 889.541L731.71 880.141L714.62 886.551Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.12 897.611L701.39 907.011L718.51 900.581L702.23 891.201L685.12 897.611Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.641 908.66L671.921 918.05L689.011 911.651L672.731 902.25L655.641 908.66Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.62 870.401L702.92 879.8L720.02 873.401L703.71 863.98L686.62 870.401Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.131 881.451L673.421 890.851L690.541 884.441L674.251 875.041L657.131 881.451Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.66 892.501L643.96 901.901L661.05 895.511L644.75 886.091L627.66 892.501Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.75 805.801L674.95 863.651L692.04 857.241L591.84 799.391L574.75 805.801Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.16 865.301L645.46 874.711L662.58 868.291L646.28 858.891L629.16 865.301Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.681 876.36L615.991 885.76L633.081 879.35L616.791 869.94L599.681 876.36Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.2 849.16L617.48 858.55L634.58 852.13L618.32 842.75L601.2 849.16Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.721 860.211L588.001 869.601L605.091 863.201L588.811 853.801L571.721 860.211Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.221 833.001L589.521 842.401L606.621 835.991L590.331 826.591L573.221 833.001Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74 844.051L560.03 853.451L577.13 847.061L560.83 837.641L543.74 844.051Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.24 816.86L561.52 826.26L578.64 819.83L562.36 810.44L545.24 816.86Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.78 827.91L532.04 837.3L549.15 830.901L532.87 821.5L515.78 827.91Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.761 789.641L563.051 799.04L580.141 792.651L563.851 783.23L546.761 789.641Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.261 800.701L533.561 810.101L550.681 803.681L534.381 794.281L517.261 800.701Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.78 811.751L504.08 821.151L521.17 814.751L504.87 805.341L487.78 811.751Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.801 773.501L535.071 782.881L552.171 776.491L535.891 767.091L518.801 773.501Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.301 784.551L505.581 793.951L522.691 787.531L506.411 778.141L489.301 784.551Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.82 795.61L476.1 804.99L493.19 798.59L476.91 789.19L459.82 795.61Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.491 790.601L422.811 821.251C422.781 822.301 423.471 823.351 424.841 824.131L666.921 963.891C669.611 965.451 674.01 965.451 676.71 963.891L777.141 905.901C778.341 905.211 779.021 904.321 779.151 903.411L780.671 893.421",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.35 210.09C363.6 241.58 364.17 263.31 366.61 290.9C367.01 295.48 368.86 298.68 371.62 300.28L391.53 311.77C388.76 310.18 386.92 306.97 386.52 302.39C384.07 274.8 383.51 253.07 386.26 221.58C387.19 210.83 394.65 198.77 403.54 193.64L523.32 124.48C528.01 121.78 532.3 121.46 535.44 123.17L515.7 111.76C512.54 109.94 508.18 110.22 503.41 112.98L383.63 182.14C374.74 187.27 367.28 199.33 366.35 210.08V210.09Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.541 193.65L523.32 124.49C528.01 121.79 532.3 121.47 535.44 123.18C538.26 124.72 540.151 127.91 540.601 132.47C543.351 160.8 542.781 183.17 540.341 213.6C539.481 224.4 531.991 236.57 523.041 241.75L503.391 253.1C503.391 265.79 513.041 276.23 521.461 277.08C495.071 290.03 483.861 277.88 475.251 269.34L403.831 310.57C399.061 313.33 394.701 313.61 391.541 311.78C388.771 310.19 386.931 306.98 386.531 302.4C384.081 274.81 383.521 253.08 386.271 221.59C387.201 210.84 394.661 198.78 403.551 193.65H403.541ZM432.201 243.99C436.491 241.52 439.961 235.5 439.961 230.55C439.961 225.61 436.491 223.61 432.201 226.08C427.91 228.55 424.441 234.57 424.441 239.52C424.441 244.46 427.91 246.46 432.201 243.99ZM463.431 225.97C467.721 223.49 471.191 217.47 471.191 212.53C471.191 207.57 467.721 205.57 463.431 208.05C459.141 210.52 455.671 216.55 455.671 221.49C455.671 226.43 459.141 228.45 463.431 225.97ZM494.861 207.82C499.151 205.34 502.621 199.32 502.621 194.38C502.621 189.44 499.151 187.42 494.861 189.9C490.571 192.37 487.101 198.4 487.101 203.34C487.101 208.28 490.571 210.3 494.861 207.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.2 226.08C427.91 228.55 424.44 234.57 424.44 239.52C424.44 244.46 427.91 246.46 432.2 243.99C436.49 241.52 439.96 235.5 439.96 230.55C439.96 225.61 436.49 223.61 432.2 226.08Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.43 208.04C459.14 210.51 455.67 216.54 455.67 221.48C455.67 226.42 459.14 228.44 463.43 225.96C467.72 223.48 471.19 217.46 471.19 212.52C471.19 207.56 467.72 205.56 463.43 208.04Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.86 189.9C490.57 192.37 487.1 198.4 487.1 203.34C487.1 208.28 490.57 210.3 494.86 207.82C499.15 205.34 502.62 199.32 502.62 194.38C502.62 189.44 499.15 187.42 494.86 189.9Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.54 311.78C394.71 313.6 399.06 313.33 403.83 310.57L475.25 269.34C483.86 277.88 495.07 290.02 521.46 277.08C513.03 276.23 503.39 265.79 503.39 253.1L523.04 241.75C532 236.58 539.48 224.4 540.34 213.6C542.79 183.18 543.35 160.8 540.6 132.47C540.15 127.91 538.26 124.72 535.44 123.18C532.3 121.47 528.01 121.79 523.32 124.49L403.54 193.65C394.65 198.78 387.19 210.84 386.26 221.59C383.51 253.08 384.08 274.81 386.52 302.4C386.92 306.98 388.77 310.18 391.53 311.78H391.54Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.67 221.48C455.67 216.54 459.14 210.51 463.43 208.04C467.72 205.57 471.19 207.57 471.19 212.52C471.19 217.46 467.72 223.48 463.43 225.96C459.14 228.43 455.67 226.42 455.67 221.48Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.101 203.34C487.101 198.4 490.571 192.37 494.861 189.9C499.151 187.43 502.621 189.43 502.621 194.38C502.621 199.33 499.151 205.34 494.861 207.82C490.571 210.29 487.101 208.28 487.101 203.34Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.96 230.55C439.96 225.61 436.49 223.61 432.2 226.08C427.91 228.55 424.44 234.57 424.44 239.52C424.44 244.46 427.91 246.46 432.2 243.99C436.49 241.52 439.96 235.5 439.96 230.55Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.54 311.78L371.63 300.29C368.87 298.69 367.02 295.48 366.62 290.91C364.17 263.32 363.61 241.59 366.36 210.1C367.29 199.35 374.75 187.29 383.64 182.16L503.42 113C508.19 110.24 512.55 109.96 515.71 111.78L535.62 123.28",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.461 956.45C536.631 963.44 535.181 968.25 531.941 970.09L506.551 984.59C509.581 982.61 510.901 977.89 509.761 971.13L446.411 593.28C444.341 580.89 434.811 566.31 425.111 560.71L32.9407 334.31C28.9007 331.98 25.4907 331.57 23.0107 332.79L48.3807 318.29C50.8807 316.86 54.4207 317.19 58.6407 319.63L450.811 546.04C460.501 551.64 470.031 566.22 472.111 578.61L535.461 956.46V956.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75 631.4L304.7 672.94C307.45 674.54 309.22 672.98 308.63 669.43L301.36 626.82C300.77 623.3 298.06 619.15 295.3 617.55L223.35 576.02V576L207.36 566.78V566.76L183.46 552.97C180.71 551.37 178.94 552.95 179.53 556.48L186.8 599.09C187.39 602.61 190.1 606.78 192.88 608.36L232.75 631.38V631.4ZM509.76 971.14C510.9 977.9 509.58 982.61 506.55 984.6L506.24 984.78C503.76 986.21 500.2 985.88 495.98 983.44L282.64 860.26C290.15 825.77 300.61 792.79 313.9 766.82L308.59 735.23L188.34 665.8C185.77 667.78 183.31 670.57 181.27 673.97C163.9 703.05 150.5 739.84 140.79 778.39L103.8 757.04C94.1104 751.44 84.5804 736.86 82.5004 724.49L19.1604 346.61C17.9904 339.62 19.4404 334.82 22.6804 332.97L23.0104 332.79C25.4904 331.58 28.9004 331.98 32.9404 334.31L425.11 560.72C434.8 566.32 444.33 580.9 446.41 593.29L509.76 971.14Z",
    fill: "#D7DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.111 968.97C350.32 970.82 351.901 973.3 351.901 975.91C351.901 979.03 349.611 982.34 345.131 984.92L244.911 1042.78C236.721 1047.52 224.35 1048.03 217.26 1043.94L56.3105 951.01C53.1005 949.16 51.5205 946.68 51.5205 944.07C51.5205 940.95 53.8105 937.64 58.2905 935.06L122.141 898.2C121.441 909.12 121.061 919.62 121.001 929.52L241.251 998.95L268.401 983.27C268.531 965.46 269.721 945.86 271.961 925.59L347.101 968.97H347.111Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.63 669.44C309.22 672.98 307.46 674.54 304.7 672.95L296.71 668.34L287.29 612.95L295.29 617.56C298.04 619.16 300.76 623.31 301.35 626.83L308.62 669.44H308.63Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 743.39C303.561 739.99 306.041 737.2 308.591 735.22L313.901 766.81C300.611 792.79 290.141 825.76 282.641 860.25C277.921 881.88 274.361 904.11 271.971 925.59C269.731 945.86 268.541 965.46 268.411 983.27L241.261 998.95C241.761 923.08 260.661 811.83 301.551 743.39H301.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59 735.22C306.04 737.2 303.56 739.99 301.54 743.39C260.66 811.83 241.75 923.08 241.25 998.95L121 929.52C121.06 919.63 121.44 909.12 122.14 898.2C124.51 860.95 130.62 818.71 140.79 778.38C150.5 739.83 163.9 703.04 181.27 673.96C183.31 670.56 185.77 667.77 188.34 665.79L308.59 735.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.311 603.72L287.291 612.95L296.711 668.34L280.721 659.11L271.311 603.72Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31 603.72L280.72 659.11L264.73 649.87L255.33 594.48L271.31 603.72Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.331 594.48L264.731 649.87L248.741 640.64L239.341 585.25L255.331 594.48Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.341 585.25L248.741 640.64L232.751 631.4L223.351 576.03L239.341 585.25Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35 576.03L232.75 631.4L216.78 622.19L207.36 566.8L223.35 576.02V576.03Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78 622.19L200.79 612.95L191.37 557.57L207.36 566.78V566.8L216.78 622.19Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.37 557.57L200.79 612.96L192.88 608.39C190.11 606.81 187.39 602.64 186.8 599.12L179.53 556.51C178.94 552.99 180.7 551.41 183.46 553L191.37 557.57Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.231 984.78C503.751 986.21 500.191 985.88 495.971 983.44L282.631 860.26",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0107 332.79C25.4907 331.58 28.9007 331.98 32.9407 334.31L425.111 560.72C434.801 566.32 444.331 580.9 446.411 593.29L509.761 971.14C510.901 977.9 509.581 982.61 506.551 984.6",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8 778.38L103.81 757.03C94.1204 751.43 84.5904 736.85 82.5104 724.48L19.1604 346.61C17.9904 339.62 19.4404 334.82 22.6804 332.97",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35 576.03L295.3 617.56C298.05 619.16 300.77 623.31 301.36 626.83L308.63 669.44C309.22 672.98 307.46 674.54 304.7 672.95L192.88 608.38C190.11 606.8 187.39 602.63 186.8 599.11L179.53 556.5C178.94 552.98 180.7 551.4 183.46 552.99L207.36 566.78",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.36 566.8L223.35 576.02",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.37 557.57L200.79 612.95",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.36 566.78V566.8L216.78 622.19",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.351 576.02V576.03L232.751 631.4V631.42",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.341 585.25L248.741 640.64V640.66",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33 594.48L264.73 649.87",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.311 603.72L280.721 659.11",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29 612.95L296.71 668.34",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23 984.78L531.93 970.09C535.18 968.25 536.63 963.44 535.45 956.45L472.1 578.6C470.03 566.21 460.5 551.63 450.8 546.03L58.6504 319.63C54.4304 317.19 50.8804 316.86 48.3904 318.29L22.6904 332.98",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.591 735.22L313.901 766.81C300.611 792.79 290.151 825.76 282.641 860.25C277.931 881.88 274.351 904.11 271.971 925.59C269.721 945.86 268.541 965.46 268.411 983.27L241.261 998.95C241.761 923.08 260.661 811.83 301.551 743.39C303.571 739.99 306.051 737.2 308.601 735.22H308.591Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25 998.95L121 929.52C121.06 919.63 121.44 909.12 122.14 898.2C124.51 860.95 130.63 818.71 140.79 778.38C150.51 739.83 163.9 703.04 181.27 673.96C183.31 670.56 185.77 667.77 188.34 665.79L308.59 735.22",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.971 925.59L347.111 968.97C350.321 970.82 351.901 973.3 351.901 975.91C351.901 979.03 349.611 982.34 345.131 984.92L244.911 1042.78C236.721 1047.52 224.35 1048.03 217.26 1043.94L56.3105 951.01C53.1005 949.16 51.5205 946.68 51.5205 944.07C51.5205 940.95 53.8105 937.64 58.2905 935.06L122.141 898.2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.7a8ef7069368c3bd6dcbf7ac4f263c9b.svg";
export { ForwardRef as ReactComponent };